export default function FileIcon({
  width = '17',
  height = '19',
  ...props
}: React.SVGProps<SVGSVGElement> & { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0714 15.5714V7.07143L10 1H3.92857C3.28447 1 2.66676 1.25587 2.21131 1.71131C1.75587 2.16676 1.5 2.78447 1.5 3.42857V15.5714C1.5 16.2155 1.75587 16.8332 2.21131 17.2887C2.66676 17.7441 3.28447 18 3.92857 18H13.6429C14.287 18 14.9047 17.7441 15.3601 17.2887C15.8156 16.8332 16.0714 16.2155 16.0714 15.5714Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1V4.64286C10 5.28695 10.2559 5.90467 10.7113 6.36012C11.1668 6.81556 11.7845 7.07143 12.4286 7.07143H16.0714"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
